import HttpService from "./HttpService";

let planejamentoAcaoService = {

    getAll: () => {
        return HttpService.backApi.get('/anoescolar/all')
    }

}

export default planejamentoAcaoService;